import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({

    itemInfo: {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        gap: "1rem",
    },
    itemInfoKey: {
        fontFamily: "Arial, Helvetica, sans-serif",
        fontWeight: "bold",
        textTransform: "uppercase",
        fontSize: "0.625rem",
    },
    itemInfoValue: {
        fontFamily: "Arial, Helvetica, sans-serif",
        fontWeight: "normal",
        textTransform: "uppercase",
        fontSize: "0.625rem",
    },
    itemInfoDateValue: {
        fontFamily: "Arial, Helvetica, sans-serif",
        fontWeight: "normal",
        fontSize: "0.625rem",
    },
}))
